import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CreditIncreaseService {
  private loadCount: number = 0;
  isLoading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  enLanguage: BehaviorSubject<boolean> = new BehaviorSubject(true);

  constructor(private http: HttpClient) {}
  currentUserData = {
    accountId: '',
    PromoName: '',
    lastFourDigits: '',
    errorPageCode: '',
    currentCreditLimit: '',
    offeredCreditLimit: '',
  };

  show() {
    this.loadCount+=1;
    this.isLoading.next(true);
  }
 
  hide() {
    this.loadCount = (this.loadCount ? --this.loadCount : 0);
    if (!this.loadCount) this.isLoading.next(false);
  }
  getCli(accountId: any) {
    return this.http.get(environment.apiUrl + '/' + accountId);
  }
  getCliPostCall(accountId: any) {
    let headers = new HttpHeaders({
      'x-api-key': environment.xApiKey,
    });
    return this.http.post(
      environment.apiUrl + '/promos',
      {
        AccountId: accountId,
        PromoName: 'cli',
      },
      { headers }
    );
  }
  // https://jrqnjtcmo7.execute-api.ca-central-1.amazonaws.com/v1/application/validate
  validateLastFour(data: any) {
    let headers = new HttpHeaders({
      'x-api-key': environment.xApiKey,
    });
    return this.http.patch(environment.apiUrl + '/promos/validate', data, { headers });
  }
  // https://yqa3r2t326.execute-api.ca-central-1.amazonaws.com/v1/promos/cli/0001213112/validate
  // https://jrqnjtcmo7.execute-api.ca-central-1.amazonaws.com/v1/application/promos
  creditLimitIncrease(data: any) {
    let headers = new HttpHeaders({
      'x-api-key': environment.xApiKey,
    });
    return this.http.patch(environment.apiUrl + '/promos/', data,{headers});
  }
}
